var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"umf-nav"},[(!_vm.hideBack)?_c('div',{staticClass:"nav-back",on:{"click":_vm.navBack}}):_vm._t("default"),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }